angular.module('jv.Admin.Users')
    .controller('jvAdminUsersAgencyDetailsController',
        ['$scope', 'agencyUserSVC', '$timeout', '$rootScope', '$location','$window', 'breadcrumbsResolve', 'TemplateLoader', 'addToReqModalConfig', 'enumToValueMap',
            function($scope, agencyUserSVC, $timeout, $rootScope, $location, $window, breadcrumbsResolve, TemplateLoader, addToReqModalConfig, enumToValueMap) {
                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.employeeDefaultSelect = $scope.employeeSelect = agencyUserSVC.employeeSelect;
                $scope.quickView = {};
                $scope.messageModal = {};
                $scope.flags.loading = false;
                $scope.isPopupOpen = false;
                $scope.paging = {};
                $scope.selectedRows = [{}];
                $scope.userReqList = {};
                $scope.map = enumToValueMap;
                $scope.isDetailsPage = true;
                $scope.editMode=false;
                $scope.field = {
                    EId: $scope.params.id,
                    templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                    isReadMode: true,
                    allOpenRequistion: {},
                    allClosedRequistion: {},
                    openRequistion: {},
                    closedRequistion: {},
                    agency: {},
                    error: {
                        required: false,
                        duplicate: false
                    },
                    show: {
                        openReq: true,
                        closeReq: true
                    }
                };

                $scope.paging.count= $scope.params.count;
                $scope.paging.index= $scope.params.index;
                $scope.paging.pageNo= $scope.params.page*1;

                $scope.getAgencyUserPagination=function(call){
                    var pageNo=$scope.paging.pageNo;
                    agencyUserSVC.getAgencyUserPagination(pageNo,function(response){
                        if(response){
                            if(response.agencyUserIds){
                                $scope.paging.list = $scope.paging.list|| [];
                                var index = pageNo*response.pageSize;
                                for(var i in response.agencyUserIds){
                                    $scope.paging.list[index++]={'Eid':response.agencyUserIds[i],'pageNo':pageNo};
                                }
                            }
                            if(response.count){
                                $scope.paging.count= response.count;
                            }
                            if(call && call=='next'){
                                $scope.next();
                            }
                            else if(call && call=='prev'){
                                $scope.prev();
                            }
                        }
                    });
                };
                
                $scope.getAgencyUserPagination();

                 $scope.prev = function(){
                    if($scope.paging.index && $scope.paging.list[$scope.paging.index-2]){
                        $scope.field.EId = $scope.paging.list[$scope.paging.index-2].Eid;
                        $scope.paging.pageNo = $scope.paging.list[$scope.paging.index-2].pageNo;
                        $scope.paging.index--;
                        $location.url('/users/agency/details/'+$scope.field.EId+'/'+$scope.paging.index+'/'+$scope.paging.count+'/'+$scope.paging.pageNo);
                        $scope.getAgencyUserDetails(true);
                    }
                    else if($scope.paging.index && !$scope.paging.list[$scope.paging.index-2] && $scope.paging.pageNo){
                        $scope.paging.pageNo--;
                        $scope.getAgencyUserPagination('prev');
                    }
                };

                $scope.next = function(){
                    if($scope.paging.index && $scope.paging.list[$scope.paging.index]){
                        $scope.field.EId = $scope.paging.list[$scope.paging.index].Eid;
                        $scope.paging.pageNo = $scope.paging.list[$scope.paging.index].pageNo;
                        $scope.paging.index++;
                        $location.url('/users/agency/details/'+$scope.field.EId+'/'+$scope.paging.index+'/'+$scope.paging.count+'/'+$scope.paging.pageNo);
                        $scope.getAgencyUserDetails(true);
                    }
                    else if($scope.paging.index && !$scope.paging.list[$scope.paging.index]){
                        $scope.paging.pageNo++;
                        $scope.getAgencyUserPagination('next');
                    }
                };
                
                $scope.isEmailValid = function(value){
                    var re= /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    return re.test(value);
                };

                $scope.saveAgencyUserDetails = function(){
                    var postParams = {};
                    $scope.field.error.required = false;
                    $scope.field.error.duplicate = false;
                    $scope.flags.loading = true;
                    $scope.field.error.invaliEmail = false;
                    
                    
                    postParams['EId'] = $scope.field.EId;
                    if($scope.field.agency.viewFields){
                        angular.forEach($scope.field.agency.viewFields, function (efield) {
                            if(efield.required){
                                if(!$scope.result[efield.EId]){
                                    $scope.field.error.required = true;
                                }else if(efield.fieldId ==-3 && !$scope.isEmailValid($scope.result[efield.EId])){
                                	$scope.field.error.invaliEmail = true;
                                }
                            }
                            if($scope.result[efield.EId])
                                postParams[efield.EId] = $scope.result[efield.EId];
                        });
                    }
                    postParams['jobIds']=[];
                    for(var reqId in $scope.result['selectedReq']){
                        postParams['jobIds'].push(reqId);
                    }
                    if($scope.field.error.invaliEmail) {
                        $scope.flags.loading = false;
                        return;
                    }
                    if(!$scope.field.error.required){
                        agencyUserSVC.saveAgencyUser(postParams,$scope.field.EId, function(response){
                        	 $scope.flags.loading=false;
                             if(response){
                                 if(response.msgInfo === "SUCCESS") {
                                	 $scope.removeMsgModal = {};
                                     $scope.showMsg('AGENCY_USERS_SAVED');
                                     $(window).off('beforeunload');
                                     $scope.field.isReadMode = true;
                                     $scope.getAgencyUserDetails(true);
                                 }
                                 else if(response.msgInfo === "EMAIL_EXIST" || response.msgInfo == 'AGENCY_EXIST' || response.msgInfo == 'EMPLOYEE_EXIST') {
                                     $scope.field.error.duplicate=true;
                                 }
                                 else if(response.msgInfo=="409"){
                                     $scope.field.error.duplicate = true;
                                     return;
                                 }
                                 else{
                                     $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                                 }
                             }
                        });
                    }
                    else{
                        $scope.flags.loading=false;
                    }
                };

                $scope.isEmailValid = function(value){
                    var re= /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    return re.test(value);
                };
                $scope.Edit = function(){
                    angular.element($window).on('beforeunload', function(){
                        return i18n.NAV_AWAY_WARNING_MESSAGE;
                    });
                    $scope.field.isReadMode = false;
                };

                $scope.showAllReq = function(reqStatus, pageSize, readMode) {
                    var data = {
                        page: 0,
                        maxResults: pageSize,
                        sortBy: 'title',
                        ownerIds: $scope.field.EId,
                        agencyJobs: true,
                        jobStateValue: ((reqStatus === 'closed') ? 2 : 1)
                    };
                    if(readMode){
                        data.readMode = 0;
                    }
                    agencyUserSVC.getReqsList($.param(data), function(res, code) {
                        if(code === 200) {
                        	if(res && res.jobs && res.jobs.length > 0) {
                        		angular.forEach(res.jobs, function (job) {
                        			if(job && job.EId) {
                        				$scope.allReqs[job.EId] = job;
                        			}
                                });

                        	}
                            if(reqStatus === 'closed') {
                                $scope.field.closedRequistion = res;
                            }
                            else {
                                $scope.field.openRequistion = res;
                            }
                        }
                    });
                };

                $scope.showReqDescription = function(item){
                    agencyUserSVC.quickView(item.EId, function(data){
                        angular.extend($scope.quickView, data.jobDetails);
                        $scope.quickView.hasJobAccess= data.hasJobAccess;
                        $scope.postOptions = data.postOptions;
                        $scope.quickView.show = 'requisitions';
                    });
                };

                $scope.showAgencyRemove= function(){
                    $scope.flags.loading=true;
                    $scope.removeMsgModal={
                            type: 'REMOVE',
                            show:true,
                            isAgency:true,
                            isToSendMail:false,
                            showLinks: false,
                            headText: i18n['REMOVE_AGENCY_USERS'],
                            showCC: false,
                            showBCC: false,
                            dontshowTemplate:false,
                            isDetailsPage:true,
                            templates:[],
                            templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                            subjectPlaceHolder: i18n['MESSAGE_TO_AGENCY'] + ' ' + i18n['DEFAULT_HEADER']
                    };
                    agencyUserSVC.getRemoveTemplates(function(response){
                        $scope.removeMsgModal.templates= $scope.select2Options.setTemplates(response.agencyRemoveTemplate);
                        angular.forEach($scope.removeMsgModal.templates, function(templt){
                            if(templt['default']){
                                $scope.removeMsgModal.template= templt;
                                $scope.removeMsgModal.subject= templt.subject;
                                $scope.removeMsgModal.body= templt.body;
                            }
                        });
                        $scope.flags.loading=false;
                    });
                };

                $scope.removeUser= function(messageType){
                    $scope.flags.loading=true;
                    $scope.removeMsgModal.checkdata = false;
                    if($scope.removeMsgModal.isToSendMail){
                        if(!$scope.removeMsgModal.subject|| ($scope.removeMsgModal.subject && $scope.removeMsgModal.subject.trim().length === 0))
                        {
                            $scope.removeMsgModal.checkdata = true;
                            $scope.flags.loading=false;
                            return;
                        }
                        if(!$scope.removeMsgModal.body|| ($scope.removeMsgModal.body && $scope.removeMsgModal.body.trim().length === 0))
                        {
                            $scope.removeMsgModal.checkdata = true;
                            $scope.flags.loading=false;
                            return;
                        }
                    }
                    var postParams = {};
                    if($scope.removeMsgModal.isToSendMail){
                        postParams['to']= [];
                        angular.forEach($scope.selectedRows, function(employee){
                            postParams['to'].push(employee.EId);
                        });
                        postParams['subject']=$scope.removeMsgModal.subject;
                        postParams['content']= $scope.removeMsgModal.body;
                        postParams['sendEmail']= $scope.removeMsgModal.isToSendMail;

                        /*BE expects locale to be sent to determine language for Email header/footer*/
                        if($scope.removeMsgModal && $scope.removeMsgModal.template){
                            postParams['locale'] = $scope.removeMsgModal.template['locale'];
                        }
                        agencyUserSVC.removeUser(postParams, function(response){
                            $scope.removeMsgModal={};
                            $scope.flags.loading=false;
                            $scope.showMsg('AGENCY_USERS_REMOVED');
                            $(window).off('beforeunload');
                            $timeout(function() {
                                window.location.href = 'index.html?readMode=0#/users/agencies';
                            }, 1000);
                        });
                    }
                    else{
                        postParams['sendEmail'] = $scope.removeMsgModal.isToSendMail;
                        postParams['userIds'] = postParams['to'] = [];
                        angular.forEach($scope.selectedRows, function(employee){
                            postParams['to'].push(employee.EId);
                        });
                        postParams['userIds']=postParams['to'];
                        agencyUserSVC.removeUser(postParams, function(response){
                            $scope.removeMsgModal={};
                            $scope.flags.loading=false;
                            $scope.showMsg('AGENCY_USERS_REMOVED');
                            $(window).off('beforeunload');
                            $timeout(function(){
                                window.location.href = 'index.html?readMode=0#/users/agencies';
                            }, 1000);
                        });
                    }
                };


                $scope.getAgencyUserDetails = function(isFastRead){
                	$scope.allReqs = {};
                    $scope.flags.loading = true;
                    isFastRead = isFastRead?isFastRead:false;
                    $(window).off('beforeunload');

                    agencyUserSVC.getAgencyUserDetails($scope.field.EId,isFastRead, function (response) {
                        angular.extend($scope.field.agency, response);
                        $scope.field.Name = response.user.firstName + " " + response.user.lastName;
                        if($scope.breadcrumbsConfig && $scope.breadcrumbsConfig.links){
                            $scope.breadcrumbsConfig.links.unshift({
                                linkText: $scope.field.Name
                            });
                        }
                        $scope.quickForms.message.to = response.user;
                        $scope.selectedRows[0].firstName=$scope.field.FirstName=response.user.firstName;
                        $scope.selectedRows[0].EId=$scope.field.EId=response.user.EId;
                        $scope.selectedRows[0].lastName=$scope.field.LastName=response.user.lastName;
                        $scope.selectedRows[0].email=$scope.field.Email=response.user.email;

                        if(response.user.invitationAcceptedDate){
                            $scope.field.agency.user.invitationAcceptedDate = new Date(response.user.invitationAcceptedDate);
                        }
                        if(response.user.invitationSentDate){
                            $scope.field.agency.user.invitationSentDate = new Date(response.user.invitationSentDate);
                        }

                        $scope.field.agency.user.actions = [];
                        angular.forEach(response.actionLinks, function (actionLink) {
                            $scope.field.agency.user.actions[actionLink.key] = actionLink.value;
                        });

                        if($scope.field.agency.viewFields){
                            angular.forEach($scope.field.agency.viewFields, function (efield) {
                                $scope.result[efield.EId] = efield.value;
                            });
                        }
                        $scope.showAllReq('open', 10, isFastRead);
                        $scope.showAllReq('closed', 10, isFastRead);
                        $scope.getAnalyticsData($scope.field.EId, isFastRead);
                        $scope.flags.loading = false;
                        $scope.editMode=false;
                    }, function (response) {
                        $scope.flags.loading = false;
                        $scope.editMode=false;
                    });
                };

                $scope.getAgencyUserDetails();

                $scope.showAgencyMessage = function(messageType){
                    $scope.flags.loading = true;
                    $scope.messageModal = {
                        type: 'INVITE',
                        show:true,
                        isAgency:true,
                        showLinks: false,
                        headText: i18n['SEND_INVITE'],
                        showCC: false,
                        showBCC: false,
                        dontshowTemplate:false,
                        agencyType:true,
                        isDetailsPage:true,
                        templates:[],
                        typeInvite:true,
                        templatePlaceHolder: i18n['MESSAGE_TO_AGENCY'],
                        subjectPlaceHolder: i18n['MESSAGE_TO_AGENCY'] + ' ' + i18n['DEFAULT_HEADER']
                    };
                    agencyUserSVC.getInviteTemplates(function(response){
                        $scope.messageModal.templates= $scope.select2Options.setTemplates(response.agencyInviteTemplate);
                        angular.forEach($scope.messageModal.templates, function(templt){
                            if(templt['default']){
                                $scope.messageModal.template= templt;
                                $scope.messageModal.subject= templt.subject;
                                $scope.messageModal.body= templt.body;
                            }
                        });
                        $scope.flags.loading=false;
                    });
                };

                $scope.showReqList=function(modalType){
                    $scope.messageModal.checkdata = false;
                    if(!$scope.messageModal.subject|| ($scope.messageModal.subject && $scope.messageModal.subject.trim().length === 0)) {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    if(!$scope.messageModal.body|| ($scope.messageModal.body && $scope.messageModal.body.trim().length === 0)) {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    var modal='addToReq';
                    agencyUserSVC.getRequisitionsFilter(function(data){
                        $scope.modals[modal].fetch = true;
                        $scope.formTemplateConfig = addToReqModalConfig($scope.postReqs, data);
                        $scope.formTemplateConfig.list.post.button.label = i18n['SEND'];
                        $scope.formTemplateConfig.list.get.filterResultsBy.list = getAlreadyAddedReqList();
                        TemplateLoader.load(modal).then(function(){
                           $scope.modals[modal].show = true;
                        });
                    });
                };

                var getAlreadyAddedReqList = function() {
                    var list = $scope.field.openRequistion.jobs || [];
                    list= $scope.field.closedRequistion.jobs && list.concat($scope.field.closedRequistion.jobs);
                    angular.forEach(list, function(job){
                        //AddToReq modal expecting job object to have job property.
                        //property is missing in BE response, hence adding it before sending to MODAL
                        job.job = {
                            EId: job.EId
                        };
                    });
                   return list;
                };

                $scope.sendAgencyMessage= function(){
                    $scope.flags.loading=true;
                    $scope.messageModal.checkdata = false;
                    if(!$scope.messageModal.subject|| ($scope.messageModal.subject && $scope.messageModal.subject.trim().length === 0)) {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    if(!$scope.messageModal.body|| ($scope.messageModal.body && $scope.messageModal.body.trim().length === 0)) {
                        $scope.messageModal.checkdata = true;
                        $scope.flags.loading=false;
                        return;
                    }
                    var postParams={};
                    postParams['to']= [];
                    postParams['jobIds']= [];
                    angular.forEach($scope.selectedRows, function(employee){
                        postParams['to'].push(employee.EId);
                    });
                    postParams['subject']=$scope.messageModal.subject;
                    postParams['content']= $scope.messageModal.body;

                    /*BE expects locale to be sent to determine language for Email header/footer*/
                    if($scope.messageModal && $scope.messageModal.template){
                        postParams['locale'] = $scope.messageModal.template['locale'];
                    }
                    if($scope.userReqList){
                        for(var reqEId in $scope.userReqList){
                            if($scope.userReqList[reqEId]){
                                postParams['jobIds'].push(reqEId);
                            }
                        }
                    }
                    agencyUserSVC.sendInvite(postParams, function(response){
                        $scope.messageModal={};
                        $scope.userReqList={};
                        $scope.selectedAgency={};
                        $scope.flags.loading=false;
                        $scope.showMsg('INVITE_SENT');
                        $scope.getAgencyUserDetails(true);
                    });
                };

                $scope.$watch('messageModal.template',function(newVal, oldVal){
                    if($scope.messageModal){
                        if(newVal){
                                if($scope.messageModal.templates){
                                    angular.forEach($scope.messageModal.templates, function(templt){
                                        if(templt.eid==newVal.eid){
                                            $scope.messageModal.subject= templt.subject;
                                            $scope.messageModal.body= templt.body;
                                        }
                                    });
                                }
                            }else{
                                $scope.messageModal.subject= '';
                                $scope.messageModal.body='';
                            }
                        }
                    },true);

                $scope.$watch('removeMsgModal.template',function(newVal, oldVal){
                    if($scope.removeMsgModal){
                        if(newVal){
                            if($scope.removeMsgModal.templates){
                                angular.forEach($scope.removeMsgModal.templates, function(templt){
                                    if(templt.eid==newVal.eid){
                                        $scope.removeMsgModal.subject= templt.subject;
                                        $scope.removeMsgModal.body= templt.body;
                                    }
                                });
                            }
                        }else{
                            $scope.removeMsgModal.subject = '';
                            $scope.removeMsgModal.body = '';
                        }
                    }
                },true);

                $scope.quickForms={
                    message:{},
                    notes:{}
                };
                
                $scope.quickForms.message = {
                    to:{},
                    show: false,
                    showError: false,
                    templates: [],
                    currentTemplate:{},
                    showTemplate: false,
                    showToggle: function() {
                        this.show = !this.show;
                        if(!this.templates.length) {
                            this.getTemplates();
                        }
                    },
                    cancel: function() {
                        $scope.quickForms.message.subject = '';
                         $scope.quickForms.message.body = '';
                        this.showToggle();
                    },
                    getTemplates: function() {
                        $scope.quickForms.message.templates = {};
                        $scope.quickForms.message.showTemplate = false;
                    },
                    setTemplate: function(templateEId) { 
                        /*Set subject and content from template*/
                        angular.forEach($scope.quickForms.message.templates, function (template) {
                            if(template.EId == templateEId){
                                $scope.quickForms.message.subject= template.subject;
                                $scope.quickForms.message.body= template.body;
                            }
                        });
                    },
                    send: function(){
                        if(!$scope.quickForms.message.subject || !$scope.quickForms.message.to){
                            $scope.quickForms.message.showError = true;
                            return;
                        }
                        var postParams = {};
                        postParams.to = $scope.quickForms.message.to.EId;
                        postParams.bcc = postParams.cc = [];
                        postParams.subject = $scope.quickForms.message.subject;
                        postParams.content = $scope.quickForms.message.body;
                        $scope.flags.loading = true;

                        agencyUserSVC.saveNote(postParams, function(response){
                            if(response.msgInfo === 200) {
                                $scope.showMsg('MESSAGE_SENT');
                            } else {
                                $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                            }
                            $scope.flags.loading = false;
                            $scope.quickForms.message.subject = '';
                            $scope.quickForms.message.body = '';
                            $scope.quickForms.message.showError = false;
                            $scope.quickForms.message.showToggle();
                        });
                    }
                };

                $scope.getAnalyticsData = function(agencyEId, readMode) {
                    $scope.field.analytics = {};
                    agencyUserSVC.getCandidateAnalytics(agencyEId, readMode, function(response) {
                        $scope.field.analytics.candidates = response.agencyUserCandidates;
                    });
                    agencyUserSVC.getRequisitionAnalytics(agencyEId, readMode, function(response) {
                        $scope.field.analytics.requisitions = response.agencyUserJobs;
                    });
                };

                $scope.modals = {
                    addToReq: {
                        show: false,
                        fetch: false
                    }
                };
                $scope.templates = TemplateLoader.register({
                    addToReq: '/jhire/modules/candidates/modals/addToReq.html'
                });

                $scope.showReqModal = function(modal) {
                    $scope.modals[modal].fetch = true;
                    agencyUserSVC.getRequisitionsFilter(function(data){
                        $scope.formTemplateConfig = addToReqModalConfig($scope.addToReqs, data);
                        TemplateLoader.load(modal).then(function(){
                           $scope.modals[modal].show = true;
                        });
                    });
                };
                
                $scope.setEditMode = function(){
                	$scope.editMode=true;
                	if($scope.result) {
                		$scope.result.selectedReq = {};
                	}
                	/*
                	 * Uncomment this after the functionality to remove already saved requisitions is implemented.
                	 */
//                	angular.forEach($scope.allReqs, function(val, key) {
//                		$scope.result.selectedReq[key] = val;
//                   });
                };
                
                $scope.clearSelectedReq = function(reqId){
                    delete $scope.result['selectedReq'][reqId];
                    if($scope.modalData && $scope.modalData[reqId]) {
                    	delete $scope.modalData[reqId];
                    }
                };
                
                $scope.addToReqs = function(modalData){
                    $scope.result['selectedReq'] = $scope.result['selectedReq'] || {};
                    $scope.modalData = modalData.selectedReqEId;
                    
                    for(var reqEId in modalData.selectedReqEId){
                        if(modalData.selectedReqEId[reqEId]){
                            for(var i=0; i < modalData.allItems.length; i++){
                                if(reqEId === modalData.allItems[i].EId){
                                    $scope.result.selectedReq[reqEId] = modalData.allItems[i];
                                    break;
                                }
                            }
                        }else{
                            //If user unchecks the req remove it from the list
                            delete $scope.result.selectedReq[reqEId];
                        }
                    }
                    modalData.selectedReqEId = {};
                    $scope.hideModals();
                };
                
                $scope.hideModals = function(){
                    angular.forEach($scope.modals, function(val, key) {
                         $scope.modals[key].show = false;
                    });
                };

                $scope.postReqs = function(modalData){
                    $scope.userReqList = modalData.selectedReqEId;
                    $scope.sendAgencyMessage($scope.currentModal);
                    $scope.hideModals();
                };
                $scope.formTemplateConfig = addToReqModalConfig($scope.postReqs, {});
            }
        ]);